import { advertiserRPO } from "advertiser/repository"
import { IAppDataLoader, IAppInitParams } from "app/model"
import { canAccessDspDeal } from "user/tools/permissions"

export const advertiserDataLoader: IAppDataLoader = async (
  params: IAppInitParams,
  onFinish: (error?: string) => any
) => {
  try {
    const advertisers = await advertiserRPO.getAllAdvertisers()
    if (canAccessDspDeal(params.userInfo)) {
      const advertiserDomains = await advertiserRPO.getAllAdvertiserDomain()
      params.advertiserDomains = advertiserDomains
    }
    params.advertisers = advertisers
    onFinish()
  } catch (error) {
    console.error(error)
    onFinish(`Advertiser data-loader error ${String(error)}`)
  }
}
